import type { BrowserRenderMode, DevTunnelRecord } from "@cmmd-forge/contracts";
import {
  devTunnelDisplayUrl,
  devTunnelIdFromUrl,
  readDevTunnelUrlClaims,
} from "@cmmd-forge/shared/devTunnelUrl";

import { localDevServerPreviewPort } from "~/lib/devServerPreviewUrl";

export function isBlankBrowserUrl(input: string | null | undefined): boolean {
  return !input || input === "about:blank";
}

export function isDevTunnelPreviewUrl(input: string): boolean {
  try {
    const url = new URL(input);
    return url.pathname.startsWith("/api/dev-tunnel/");
  } catch {
    return false;
  }
}

export function devTunnelRecordForUrl(
  input: string,
  devTunnelRecords: ReadonlyArray<DevTunnelRecord>,
): DevTunnelRecord | null {
  const tunnelId = devTunnelIdFromUrl(input);
  if (!tunnelId) {
    return null;
  }
  return (
    devTunnelRecords.find((record) => record.tunnelId === tunnelId || record.publicUrl === input) ??
    null
  );
}

export function readDevTunnelMetadata(
  input: string,
  devTunnelRecords: ReadonlyArray<DevTunnelRecord> = [],
): { readonly localPort?: number; readonly expiresAt?: string } | null {
  const record = devTunnelRecordForUrl(input, devTunnelRecords);
  if (record) {
    return {
      localPort: record.localPort,
      expiresAt: record.expiresAt,
    };
  }
  return readDevTunnelUrlClaims(input);
}

export function browserDisplayUrl(
  input: string | null,
  devTunnelRecords: ReadonlyArray<DevTunnelRecord> = [],
): string | null {
  return devTunnelDisplayUrl(input, input ? readDevTunnelMetadata(input, devTunnelRecords) : null);
}

export function isLocalPreviewBrowserUrl(
  url: string,
  devTunnelRecords: ReadonlyArray<DevTunnelRecord>,
): boolean {
  const displayUrl = browserDisplayUrl(url, devTunnelRecords);
  return Boolean(isDevTunnelPreviewUrl(url) || localDevServerPreviewPort(displayUrl ?? url));
}

export function resolveBrowserRenderMode(_input: string): BrowserRenderMode {
  return "interactive" satisfies BrowserRenderMode;
}
